import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateStreamMutation } from "../graphql/mutations";
import type {
  UpdateStreamMutationType,
  UpdateStreamMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateStreamMutation = (
  options?: MutationHookOptions<
    UpdateStreamMutationType,
    UpdateStreamMutationVariablesType
  >
) => {
  return useMutation<
    UpdateStreamMutationType,
    UpdateStreamMutationVariablesType
  >(UpdateStreamMutation, options);
};
